angular.module('unica_user.user_services')

.factory('UserCreateService', function ($http, getBaseApiURL) {

	var userCreateService = {};

	userCreateService.create = function (userData) {
		var userData = angular.copy(userData);

		userData.dob = moment( userData.dob ).format('YYYY-MM-DD');

		if ( userData.doc_emission_date ) {
			userData.doc_emission_date = moment( userData.doc_emission_date ).format('YYYY-MM-DD');
		}

		if ( userData.doc_expiration_date ) {
			userData.doc_expiration_date = moment( userData.doc_expiration_date ).format('YYYY-MM-DD');
		}

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/create',
			data: userData
		}).then(function(result) {
			if ( result ) {
				return result.data.user;
			}
		});

	};

	return userCreateService;
});